import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, Routes, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from './app/services/auth.service';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { AppComponent } from './app/app.component';
import { HomeComponent } from './app/pages/home.component';
import { LoginComponent } from './app/pages/login.component';
import { AdminComponent } from './app/pages/admin.component';
import { AdminBandsComponent } from './app/pages/admin-bands.component';
import { SettingsComponent } from './app/pages/settings.component';
import { FestivalComponent } from './app/pages/festival.component';

function adminGuard(): Promise<boolean | UrlTree> | boolean | UrlTree {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.isAdmin().then(isAdmin => isAdmin ? true : router.createUrlTree(['/']));
}

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'festival/:id', component: FestivalComponent },
  { path: 'login', component: LoginComponent },
  { path: 'settings', component: SettingsComponent },
  { path: 'share', redirectTo: 'settings' },
  { path: 'admin', component: AdminComponent, canActivate: [adminGuard] },
  { path: 'admin/festivals/:id/bands', component: AdminBandsComponent, canActivate: [adminGuard] },
  { path: '**', redirectTo: '' }
];

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    provideHttpClient(withFetch())
  ]
}).catch(err => console.error(err));
